
import React from 'react'
import './main.styles.scss';
import HeaderComponent from '../../header/HeaderComponent'
import SideBar from '../../SideBar/SideBar';

export const MainSalesLayoutComponent = props => {
    return (
        <div className='main-layout'>
            <div className='first'>
                {/* <SidebarComponent /> */}
                <SideBar />
            </div>
          
            <div style={{backgroundColor:'white'}} className='main-area' >
             <HeaderComponent />
                {props.children}
            </div>
        </div>
    )
}


export default MainSalesLayoutComponent